import { Box } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import React from 'react';

export type StatePlacement = 'content' | 'window';

const centredSx: SystemStyleObject<Theme> = {
  boxSizing: 'border-box',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: 'auto',
  alignSelf: 'stretch',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
};

const PLACEMENT_SX: Readonly<Record<StatePlacement, SystemStyleObject<Theme>>> = {
  content: centredSx,
  window: {
    ...centredSx,
    minHeight: '100vh',
    '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
    paddingInline: 4,
  },
};

export interface StateAreaProps {
  readonly placement?: StatePlacement;
  readonly children: React.ReactNode;
}

export const StateArea: React.FC<StateAreaProps> = ({ placement = 'content', children }) => (
  <Box data-placement={placement} sx={PLACEMENT_SX[placement]}>
    {children}
  </Box>
);
